import {Colors, MappedStatus, OracleStatus, TaskStatus} from '@entities/common/common.enums';
import {ChipOptions} from '@entities/common/common.interface';
import {RightsFranchise} from '@entities/rights/rights.interfaces';

/** Auxiliary 'NO_DATA_COLOR' variable.' */
export const NO_DATA_COLOR = '#ffffff';

/** Auxiliary 'TASK_STATUS_CHIPS_OPTIONS' variable.' */
export const TASK_STATUS_CHIPS_OPTIONS: {[key in TaskStatus]: ChipOptions} = {
	[TaskStatus.Open]: {
		color: Colors.NotMapped,
		label: 'not mapped',
	},
	[TaskStatus.InProgress]: {
		color: Colors.PreMapped,
		label: 'pre-mapped',
	},
	[TaskStatus.Done]: {
		color: Colors.Mapped,
		label: 'mapped',
	},
	[TaskStatus.Reset]: {
		color: null,
		label: '',
	},
};

/** Auxiliary 'MERGE_TYPE_CHIPS_OPTIONS' variable.' */
export const MERGE_TYPE_CHIPS_OPTIONS: {[key in MappedStatus]: ChipOptions} = {
	[MappedStatus.Mapped]: {
		color: Colors.Mapped,
		label: 'mapped',
		iconKey: 'thumb-up',
	},
	[MappedStatus.NotMapped]: {
		color: Colors.NotMapped,
		label: 'not mapped',
		iconKey: 'alert',
	},
	[MappedStatus.PreMapped]: {
		color: Colors.PreMapped,
		label: 'pre-mapped',
		iconKey: 'help',
	},
};

/** Auxiliary 'NON_RL_STATUS_CHIP_OPTIONS' variable.' */
export const NON_RL_STATUS_CHIP_OPTIONS: {[key in OracleStatus]: ChipOptions} = {
	[OracleStatus.Mapped]: {
		color: Colors.OracleMapped,
		label: 'mapped',
		iconKey: 'thumb-up',
	},
	[OracleStatus.NotMapped]: {
		color: Colors.OracleNotMapped,
		label: 'not mapped',
		iconKey: 'alert',
	},
};

/** Auxiliary 'RL_STATUS_CHIP_OPTIONS' variable.' */
export const RL_STATUS_CHIP_OPTIONS: {[key in OracleStatus]: ChipOptions} = {
	[OracleStatus.Mapped]: {
		color: Colors.RLOracleMapped,
		label: 'mapped',
		iconKey: 'thumb-up',
	},
	[OracleStatus.NotMapped]: {
		color: Colors.RLOracleNotMapped,
		label: 'not mapped',
		iconKey: 'alert',
	},
};

/** Auxiliary 'MDM_COLORS' variable.' */
export const MDM_COLORS = {
	bunting: '#2B344D',
	rouge: '#A03C7D',
	wedgewood: '#125858',
	salem: '#3a73a2',
	gold: '#e7c821',
	iconColor: '#ffffff',
};

/** Auxiliary 'GM_SOURCE_COLORS' variable.' */
export const GM_SOURCE_COLORS: Record<RightsFranchise, string> = {
	[RightsFranchise.RL]: MDM_COLORS.rouge,
	[RightsFranchise.RLJE]: MDM_COLORS.wedgewood,
	[RightsFranchise.RLJE_STUDIO]: MDM_COLORS.salem,
	[RightsFranchise.GOLDEN]: MDM_COLORS.gold,
	[RightsFranchise.HIDIVE]: MDM_COLORS.gold,
};
